import OrderMgmtCardStyles from './card.styles';
import Typography, {
  FontWeight,
  Variants,
} from '../../../../common/typography';
import { useOrderMgmtLang } from '../../../hooks';
import { OrderMgmtProduct } from '../../../../../business/order-mgmt';
import { useProductCard } from './hooks';
import Box from '@material-ui/core/Box';
import { Disclaimer, Suggestions, ToppingCard } from './components';
import { ChipOrderDisclaimer } from 'components/order-management/components/order-mgmt-dialog/components';

export const ProductCard = ({ product, orderId }: Props) => {
  const {
    id,
    units,
    name,
    description,
    toppings,
    subtotal,
    suggestions,
  } = product;
  const { soldOutProductText } = useOrderMgmtLang({
    orderId,
  });
  const {
    hasProductItemSuggestions,
    deleteProduct,
    deleteTopping,
    isEnabledToDelete,
  } = useProductCard({ product });

  const componentClasses = OrderMgmtCardStyles();

  return (
    <Box display='flex' flexDirection='column'>
      <Box
        className={componentClasses.cardContainer}
        display='flex'
        width='100%'
        flexDirection='column'
        padding='0 1rem'
        marginBottom='0.5rem'
      >
        <Box
          className={componentClasses.titleContainer}
          display='flex'
          alignItems='center'
          position='relative'
          padding='0.5rem 0'
        >
          <Typography
            classes={{ root: componentClasses.quantity }}
            fontWeight={FontWeight.SemiBold}
          >
            {`${units}x`}
          </Typography>
          <Box
            display='flex'
            alignItems='center'
            justifyContent='space-between'
            width='100%'
          >
            <Box display='flex' alignItems='center' gridGap='0.5rem'>
              <Typography classes={{ root: componentClasses.title }}>
                {name}
              </Typography>
              <ChipOrderDisclaimer
                type='warning'
                disclaimer={soldOutProductText}
                classes={{
                  disclaimer: componentClasses.chipDisclaimer,
                  text: componentClasses.chipText,
                }}
              />
            </Box>
            <Box display='flex' alignItems='center' gridGap='0.25rem'>
              <Typography
                classes={{ root: componentClasses.subtotal }}
                fontWeight={FontWeight.SemiBold}
              >
                {subtotal}
              </Typography>
              {hasProductItemSuggestions && (
                <Disclaimer
                  enabledToDelete={product.hasSuggestions && isEnabledToDelete}
                  classDelete={componentClasses.deleteItem}
                  item={product}
                  onDelete={deleteProduct}
                />
              )}
            </Box>
          </Box>
        </Box>
        <Box className={componentClasses.cardBody}>
          {hasProductItemSuggestions && (
            <Suggestions
              productName={name}
              suggestions={suggestions}
              units={units}
              enabledDisclaimer
            />
          )}
          <Typography
            classes={{ root: componentClasses.description }}
            variant={Variants.Caption2}
          >
            {description}
          </Typography>
          {toppings && (
            <Box display='flex' flexDirection='column' gridGap='0.5rem'>
              {toppings.map(topping => (
                <ToppingCard
                  topping={topping}
                  key={`t-${topping?.id}`}
                  onDelete={deleteTopping}
                />
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

interface Props {
  product: OrderMgmtProduct;
  orderId: number;
  hasDelete?: boolean;
}
